import { CashMovementHistory } from "../../types/cash/movement";
import { CustomColumn } from "../../types/customColumn";

export const cashAdjustmentColumns: CustomColumn<CashMovementHistory>[] = [

  {
    Header: "Fecha",
    accessor: "movementDate",
    customCell: ({ row }) => (
      <span className="text-sm text-gray-700 dark:text-gray-300">
        {row.original.movementDate}
      </span>
    ),
  },

  {
    Header: "Monto",
    accessor: "amount",
    customCell: ({ row }) => {

      const amount = row.original.amount;

      return (
        <span className={`text-sm font-semibold ${amount >= 0 ? "text-green-600" : "text-red-600"}`}>
          {amount >= 0 ? "+" : "-"}${Math.abs(amount).toFixed(2)}
        </span>
      );

    },
  },

  {
    Header: "Descripción",
    accessor: "description",
    customCell: ({ row }) => (
      <span className="text-sm text-gray-700 dark:text-gray-300">
        {row.original.description || "-"}
      </span>
    ),
  },

  {
    Header: "Usuario",
    accessor: "createdByName",
    customCell: ({ row }) => (
      <span className="text-sm font-medium text-black dark:text-white">
        {row.original.createdByName}
      </span>
    ),
  },

];